<template>
    <div>
        <froala :class="{invalid: isInvalid}" :id="id" :name="name" :required="_required" tag="textarea" :config="editorConfig" v-model:value="input"
        v-bind="ariaValidationAttributes" ref="editor"></froala>
        <textarea v-if="!initialized" v-show="false" :name="name" v-model="input"></textarea>
    </div>
</template>

<script lang="ts">
    import {FroalaDefaultConfig} from '@/library/froala';
    import {Component, Prop, Watch} from 'vue-facing-decorator';
    import {AbstractFormInput} from '@/mixins/AbstractFormInput';
    import FroalaEditor, {FroalaOptions} from 'froala-editor';

    @Component({
        name: 'FormTextEditor',
        emits: ['update:modelValue', 'instance-ready'],
    })
    export class FormTextEditor extends AbstractFormInput
    {
        readonly $refs: {
            editor: {getEditor: () => FroalaEditor, createEditor: Function, destroyEditor: Function},
        };

        @Prop({
            type: String,
            default: '',
            required: false,
        }) modelValue: string;

        @Prop({
            type: String,
            required: true,
        }) id: string;

        @Prop({
            type: String,
            default: 'Intranet',
            required: false,
        }) toolbar: string;

        @Prop({
            type: Object,
        }) config: Partial<FroalaOptions>;

        get editorConfig()
        {
            const options: Partial<FroalaOptions> = {
                initializationCallbacks: [
                    (editor: FroalaEditor) => {
                        this.$emit('instance-ready');
                    }
                ],
            };

            if (!this.config)
            {
                return Object.assign({}, FroalaDefaultConfig, options);
            }

            return Object.assign({}, FroalaDefaultConfig, options, this.config);
        }

        type = 'text'; // unused?

        input = '';

        checkInterval: Nullable<number> = null;

        initialized: boolean = false;

        @Watch('input')
        watchInput(value: string)
        {
            this.$emit('update:modelValue', value);
        }

        @Watch('modelValue')
        watchValue()
        {
            this.input = this.modelValue;
        }

        created()
        {
            this.input = this.modelValue;

            this.watchInitialization().then(() => {
                this.initialized = true;

                this.emitter.emit('initialized');
            });
        }

        unmounted()
        {
            this.clearCheckInterval();
        }

        clearCheckInterval()
        {
            this.checkInterval && window.clearInterval(this.checkInterval);
        }

        watchInitialization()
        {
            return new Promise<void>(resolve => {
                this.checkInterval = window.setInterval(() =>
                {
                    if (this.$refs.editor && this.$refs.editor.getEditor() && this.$refs.editor.getEditor().html)
                    {
                        this.clearCheckInterval();
                        resolve();
                    }
                }, 100);
            });
        }

        getEditor()
        {
            return this.$refs.editor.getEditor();
        }

        updateValue()
        {
            return this.validateValue(this.input);
        }

        loadEditor()
        {
            this.$refs.editor.createEditor();
        }

        unloadEditor()
        {
            this.$refs.editor.destroyEditor();
        }
    }

    export default FormTextEditor;
</script>